import { createAsyncThunk } from '@reduxjs/toolkit';
import { push, replace } from 'redux-first-history';
import * as API from '../api/index.js';
import fetchHelper from '../utils/fetchHelper.js';
import { setUser, removeUser } from '../utils/storageHelper.js';
import { getHumanError } from '../utils/humanErrors.js';
import { notification } from 'antd';

export const loginUser = createAsyncThunk('userAuth/login', async ({ user }, { rejectWithValue }) => {
    try {
        const result = await API.auth.login(user);
        const token = result.token;
        fetchHelper.setToken(token);
        setUser(result);

        return result;
    } catch (error) {
        removeUser();
        notification.error({ message: 'Error', description: error.message || 'Server error' });
        return rejectWithValue(getHumanError(error.message));
    }
});

export const logoutUser = createAsyncThunk('userAuth/logout', async (_, { dispatch }) => {
    try {
        dispatch(replace('/'));
        await API.auth.logout();
    } catch (error) {
        console.error(error.message);
    } finally {
        removeUser();
    }
});

export const getUserByToken = createAsyncThunk('userAuth/getUserByToken', async (_, { dispatch, rejectWithValue }) => {
    try {
        const result = await API.auth.getUserByCookie();
        setUser(result);
        dispatch(push('/dashboard'));
        return result;
    } catch {
        return rejectWithValue(null);
    }
});

export const getUserBySecretKey = createAsyncThunk('userAuth/getUserBySecretKey', async (_, { rejectWithValue }) => {
    try {
        const result = await API.auth.getUserByCookie();

        if (!result) {
            return rejectWithValue('No user session found');
        }

        fetchHelper.setToken(result.token);
        setUser(result);

        return result;
    } catch (error) {
        return rejectWithValue(error.message || 'Invalid secret key');
    }
});

export const loginUserGoogle = createAsyncThunk('userAuth/loginGoogle', async (_, { rejectWithValue }) => {
    try {
        const { url } = await API.auth.loginGoogle();
        window.location = url;
        return true;
    } catch (error) {
        return rejectWithValue(error.message);
    }
});

export const loginUserMicrosoft = createAsyncThunk('userAuth/loginMicrosoft', async (_, { rejectWithValue }) => {
    try {
        const { url } = await API.auth.loginMicrosoft();
        window.location = url;
        return true;
    } catch (error) {
        return rejectWithValue(error.message);
    }
});

export const fetchPermissionsThunk = createAsyncThunk('userAuth/fetchPermissions', async (_, { rejectWithValue }) => {
    try {
        const permissions = await API.user.getPermissions();
        return permissions;
    } catch (error) {
        return rejectWithValue(error.message || 'Server error');
    }
});
